import styled from 'styled-components'

import { RowLabel as DefaultRowLabel } from '../Shared'

export const RowLabel = styled(DefaultRowLabel)`
	margin: 0 0 10px;
`
